// --- START OF FILE adminTasksApi.js ---
// src/api/adminTasksApi.js

import axios from 'axios';
import { handleAxiosError } from './handleApiError'; // Assuming you have a helper for error handling

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

// GET /auth/api/users - Fetch all users (Admin only)
export const fetchUsers = async (token) => {
    console.debug("[adminTasksApi] Fetching all users...");

    try {
        const response = await axios.get(`${API_BASE_URL}/auth/api/users`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        // Assuming backend returns 200 OK with user list on success
        return { status: true, data: response.data };
    } catch (error) {
        console.error("[adminTasksApi] Error fetching users:", error);
        return handleAxiosError(error, "Failed to fetch users.");
    }
};

// POST /auth/api/signupUser - Admin signs up a new user
export const adminSignupUser = async (token, userData) => {
    console.debug("[adminTasksApi] Signing up new user via Admin:", userData.email);

    try {
        // userData should include { userName, email, password }
        const response = await axios.post(`${API_BASE_URL}/auth/api/signupUser`, userData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        // Assuming backend returns 201 Created or 200 OK with user details on success
        return { status: true, message: response.data?.message || 'User signed up successfully.', data: response.data };
    } catch (error) {
        console.error("[adminTasksApi] Error signing up user:", error);
        return handleAxiosError(error, "Failed to sign up user.");
    }
};

// POST /auth/api/moveInfluencers - Move influencers between users
export const moveInfluencers = async (token, fromUserId, toUserId, influencerIdsToMove) => {
    // influencerIdsToMove can be array of IDs or the string 'all'
    console.debug(`[adminTasksApi] Moving influencers from ${fromUserId} to ${toUserId}:`, influencerIdsToMove);

    try {
        const payload = {
            fromUserId,
            toUserId,
            influencerIds: influencerIdsToMove,
        };
        const response = await axios.post(`${API_BASE_URL}/auth/api/moveInfluencers`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
         // Assuming backend returns 200 OK with a message and count on success
         return { status: true, message: response.data?.message || 'Influencers moved successfully.', data: response.data };
    } catch (error) {
        console.error("[adminTasksApi] Error moving influencers:", error);
        return handleAxiosError(error, "Failed to move influencers.");
    }
};

// DELETE /auth/api/deleteUser/<uid> - Admin deletes a user
export const deleteUserAdmin = async (token, userIdToDelete) => {
    console.debug("[adminTasksApi] Deleting user via Admin:", userIdToDelete);

    try {
        const response = await axios.delete(`${API_BASE_URL}/auth/api/deleteUser/${userIdToDelete}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
         // Assuming backend returns 200 OK with a message on success
         return { status: true, message: response.data?.message || 'User deleted successfully.', data: response.data };
    } catch (error) {
        console.error("[adminTasksApi] Error deleting user:", error);
        return handleAxiosError(error, "Failed to delete user.");
    }
};

// --- END OF FILE adminTasksApi.js ---